/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import{getMetersPerUnitForSR as o}from"../../core/unitUtils.js";import r from"../../geometry/support/MeshTransform.js";function t(t){const e=1/o(t,1);return 1!==e?new r({scale:[e,e,e]}):void 0}export{t as getMeshTransformForMetersToSpatialReference};
